import React from 'react';
import { TextField, Typography, Box } from '@mui/material';
import { FormFieldProps } from '../../types/profileForm.types';

const FormField: React.FC<FormFieldProps> = ({
  label,
  name,
  type,
  value,
  error,
  placeholder,
  required = false,
  onChange,
  onBlur,
  disabled = false, // ✅ new
  inputProps = {},  // ✅ new
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (!disabled) {
      onChange(name, event.target.value);
    }
  };

  const handleBlur = () => {
    if (!disabled) {
      onBlur(name);
    }
  };

  return (
    <Box sx={{ mb: 1, display: 'flex', alignItems: type === 'textarea' ? 'flex-start' : 'center' }}>
      <Typography
        variant="subtitle1"
        sx={{
          minWidth: { xs: '120px', sm: '200px' },
          flexShrink: 0,
          fontSize: '14px',
          fontWeight: 600,
          color: '#212529',
          pt: type === 'textarea' ? 1 : 0,
        }}
      >
        {label}
        {required && (
          <Typography component="span" sx={{ color: '#dc3545', ml: 0.5 }}>
            *
          </Typography>
        )}
      </Typography>

      <Box sx={{ flex: 1 }}>
        <TextField
          name={name}
          type={type === 'textarea' ? 'text' : type}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={placeholder}
          multiline={type === 'textarea'}
          rows={type === 'textarea' ? 4 : 1}
          error={!!error}
          helperText={error}
          fullWidth
          disabled={disabled}           // ✅ disable the field
          inputProps={inputProps}       // ✅ allows readOnly, aria-readonly, etc.
          sx={{
            '& .MuiOutlinedInput-root': {
              height: type === 'textarea' ? 'auto' : '48px',
              borderRadius: '8px',
              fontSize: '16px',
              backgroundColor: disabled ? '#f8f9fa' : '#fff', // ✅ light gray when disabled
              '& fieldset': {
                borderColor: error ? '#dc3545' : '#dee2e6',
                borderWidth: '1px',
              },
              '&:hover fieldset': {
                borderColor: error ? '#dc3545' : '#007bff',
              },
              '&.Mui-focused fieldset': {
                borderColor: error ? '#dc3545' : '#007bff',
                borderWidth: '2px',
              },
              '& input, & textarea': {
                padding: '12px 16px',
                fontSize: '16px',
              },
            },
            '& .MuiFormHelperText-root': {
              fontSize: '12px',
              color: '#dc3545',
              marginLeft: 0,
              marginTop: '4px',
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default FormField;
